module.exports = __webpack_public_path__ + "8a5356e9/img/menu-icon.5f8facae.svg";